import Required from '../required'
import ValidationErrors from './validation-errors'

export default {
  components: { Required, ValidationErrors },

  props: {
    initialValue: {
      type: [Number, String, Boolean],
      required: false
    },
    inputName: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    validationErrors: {
      type: Array,
      required: false
    }
  },

  emits: ['change'],

  data() {
    return {
      value: this.initialValue
    }
  },

  computed: {
    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  watch: {
    initialValue() {
      this.value = this.initialValue
    }
  },

  methods: {
    displayNameForOption(option) {
      return option[0]
    },

    emitNewValue() {
      this.$emit('change', this.value)
    },

    inputId(option) {
      return `${this.inputName}-${option[1]}`
    },

    valueForOption(option) {
      return option[1]
    }
  }
}
